<template>
  <div class="text-sm">
    <p class="mt-6">
      <b>2024.12.09</b> - AI fixes & improvements, Caverns performance, and game balance.
    </p>
    <ul class="ml-5 pb-4 list-outside list-disc">
      <li>
        Balance
        <ul>
          <li>
            - Nerfed Adrenaline
            <ul>
              <li class="pl-4">
                * MP Cost: <code>75 - L</code> -->
                <code>150 - L*3</code>
              </li>
              <li class="pl-4">
                * AP Gain: <code>25 + L*( St/12 )</code> -->
                <code>10 + L*( St/12 )</code>
              </li>
            </ul>
          </li>
          <li>
            - Boosted Layers of Protection potency:
            <code>L*1.5</code> --> <code>L*5</code>
          </li>
          <li>
            - Increased Healing Prayer AP cost: <code>20</code> -->
            <code>45</code>
          </li>
          <li>
            - Nerfed Sanctuary
            <ul>
              <li class="pl-4">* AP Cost: <code>25</code> --> <code>65</code></li>
              <li class="pl-4">
                * MP Cost: <code>30 + L*5</code> -->
                <code>40 + L*6</code>
              </li>
              <li class="pl-4">* Effect Range: <code>3</code> --> <code>2</code></li>
            </ul>
          </li>
          <li>
            - Nerfed Infect Mind
            <ul>
              <li class="pl-4">* AP Cost: <code>10</code> --> <code>30</code></li>
              <li class="pl-4">
                * MP Cost: <code>20 + L*2</code> -->
                <code>20 + L*5</code>
              </li>
            </ul>
          </li>
          <li>
            - Adusted summoning spells' MP Cost scaling:
            <code>L*50</code> --> <code>100+L*40</code>
          </li>
        </ul>
      </li>
      <li>
        AI
        <ul>
          <li>- Heroes will now target only heroes (not summons)</li>
          <li>
            - Units should no longer perform actions before the results of the previous
            action are calculated (e.g. shooting arrows at dead enemies).
          </li>
          <li>
            - Units should no longer do Roundhouse when there aren't enemies in range.
          </li>
          <li>
            - Changed the way "best melee target" is calculated. Units should no longer
            break away from nearby enemies to go after a distant enemy with low HP. Also
            fixes the wasting-a-turn-running-back-and-forth bug.
          </li>
          <li>- Units should no longer pass turns with full AP</li>
          <li>- Units should now stack Armor Break appropriately</li>
          <li>- Units should now use Mortal Strike on slowed targets</li>
          <li>- CC abilities should no longer be duplicated</li>
          <li>
            - Units should now use Stance Dancing appropriately (defensive for tanks,
            offensive for DPS)
          </li>
          <li>
            - Ranged DPS should now use a variety of equipped abilities (including
            Fumigate and Lightning)
          </li>
          <li>- Improved the targeting for DoT abilities</li>
        </ul>
      </li>
      <li>... aaaand ... drastically improved Caverns CPU performance</li>
    </ul>
  </div>
</template>
